import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallRenewal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m1.998 6.666 2.57-2.57a4.9 4.9 0 0 1 3.457-1.432v0c1.999 0 3.796 1.217 4.539 3.073l.105.262"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.665 6.668H1.998V4M14.003 9.336l-2.57 2.57a4.9 4.9 0 0 1-3.458 1.432v0a4.89 4.89 0 0 1-4.539-3.074l-.104-.261"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.335 9.336h2.668v2.668"
    />
  </svg>
);
export default SvgSmallRenewal;
